import { useEffect, useState } from 'react';
import styles from './collapseModal.module.css';
import { CollapseModalProps } from './collapseModal.types';

const CollapseModal = (props: CollapseModalProps) => {
  const [expand, setExpand] = useState(props.expand ?? false);

  useEffect(() => {
    if (props.expand !== undefined) setExpand(props.expand);
  }, [props.expand]);

  return (
    <div className={styles.collapseModal}>
      <div className={styles.header} onClick={() => setExpand(!expand)}>
        <span className={styles.icon}>{expand ? '-' : '+'}</span>
        {props.headerContent}
      </div>
      {expand && <div className={styles.content}>{props.children}</div>}
    </div>
  );
};

export default CollapseModal;
